import React, { useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel'; // Import Owl Carousel JS (Important for react-owl-carousel v2.3.1 and below)
import AOS from 'aos';
import 'aos/dist/aos.css';

import Reactimg from './images/Tech icons/1.png';
import javaimg from './images/Tech icons/1.png';
import mernimg from './images/Tech icons/2.png'
import phpimg from './images/Tech icons/3.png';

import pythonimg from './images/Tech icons/4.png';
import nodeimg from './images/Tech icons/5.png';
import Cimg from './images/Tech icons/6.png';
import dataimg from './images/Tech icons/7.png';
import androidimg from './images/Tech icons/8.png';
import iosimg from './images/Tech icons/9.png';
import AIimg from './images/Tech icons/10.png'
import awsimg from './images/Tech icons/12.png'
import devopsimg from './images/Tech icons/11.png'
import cyberimg from './images/Tech icons/13.png'
import blockchainimg from './images/Tech icons/14.png'
import IOTimg from './images/Tech icons/15.png'
import sqlimg from './images/Tech icons/16.png'
import testimg from './images/Tech icons/17.png'
import bigdataimg from './images/Tech icons/18.png'
import promptimg from './images/Tech icons/19.png'
import uiimg from './images/Tech icons/20.png'

import { Link } from 'react-router-dom';



const HomeAllCourses = () => {

    useEffect(() => {
        AOS.init();
    }, []);


    const options = {
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        autoplay: true,
        smartSpeed: 2500,
        autoplayTimeout: 3000,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            800: { items: 3 },
            1150: { items: 4 },
        },
    };





    return (
        <div className='home_all_courses' data-aos="fade-up" data-aos-duration="2000">
            <div className="container-fluid">
                <div>
                    <div className="ourTechnologies" >
                        <h2>Programming Technologies Offered</h2>
                        <p>At Hamo Tech, we provide a comprehensive suite of programming courses designed to meet the demands of today's fast-evolving tech landscape. Whether you are just starting out or looking to advance your existing knowledge, our courses will give you the skills necessary to succeed in the software development world. Dive into these programming technologies that are critical for building the future</p>
                    </div>

                    <OwlCarousel className="owl-theme mt-5" {...options} > {/* Use the OwlCarousel Component */}

                        <div className='card home_all_courses_cards'>
                            <img src={javaimg} />

                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Java Full Stack Development</h4>
                                <p className='text-justify'>Java Full Stack Development involves building both front-end and back-end applications using Java technologies. It includes frameworks like Spring Boot for the backend and React or Angular for the frontend. Developers work with databases, APIs, and cloud services to create scalable applications. This role requires expertise in Java, web technologies, and DevOps for efficient deployment.</p>



                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>



                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={mernimg} />

                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p>Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Full Stack Development (MERN/MEAN Stack)</h4>
                                <p className='text-justify'>Full Stack Development with MERN (MongoDB, Express.js, React, Node.js) and MEAN (MongoDB, Express.js, Angular, Node.js) enables building dynamic and scalable web applications. It covers both front-end and back-end development, ensuring seamless data flow and user interactions. With JavaScript as the core language, it simplifies development and enhances efficiency. </p>



                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>



                            </div>
                        </div>





                        <div className='card home_all_courses_cards'>
                            <img src={pythonimg} />

                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Python Programming & Machine Learning</h4>
                                <p className='text-justify'> Python is a versatile programming language known for its simplicity and powerful libraries. It is widely used in machine learning for data analysis, model building, and automation. With libraries like TensorFlow, Scikit-learn, and Pandas, Python enables efficient AI development. Its flexibility makes it ideal for beginners and experts in data science.</p>



                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>



                            </div>
                        </div>


                        <div className='card home_all_courses_cards'>
                            <img src={dataimg} />

                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Data Science & Analytics</h4>
                                <p className='text-justify'>  Data Science & Analytics empower businesses to extract insights from vast amounts of data, enabling smarter decision-making. By leveraging machine learning, statistical models, and visualization techniques, organizations can uncover patterns and trends. It plays a crucial role in industries like healthcare, finance, and marketing, driving innovation and efficiency. </p>



                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>



                            </div>
                        </div>




                        <div className='card home_all_courses_cards'>
                            <img src={AIimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Artificial Intelligence & Deep Learning</h4>
                                <p className='text-justify'> Artificial Intelligence (AI) enables machines to mimic human intelligence, solving complex problems and automating tasks. Deep Learning, a subset of AI, uses neural networks to process vast amounts of data, improving accuracy in decision-making. AI powers applications like chatbots, self-driving cars, and recommendation systems. </p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>



                        <div className='card home_all_courses_cards'>
                            <img src={awsimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Cloud Platform</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Cloud Computing (AWS, Azure, Google Cloud)</h4>
                                <p className='text-justify'> Cloud computing enables businesses to access computing resources like servers, storage, and databases over the internet. AWS, Azure, and Google Cloud are the leading providers, offering scalable and secure solutions for various applications. These platforms support AI, big data, and DevOps, enhancing performance and cost efficiency.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>



                        <div className='card home_all_courses_cards'>
                            <img src={devopsimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Methodology</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>DevOps & CI/CD Pipelines</h4>
                                <p className='text-justify'>DevOps streamlines software development and IT operations, ensuring faster and more reliable deployments. CI/CD pipelines automate code integration, testing, and deployment, reducing manual efforts and errors. Continuous Integration (CI) ensures frequent code merges, while Continuous Deployment (CD) delivers updates seamlessly. </p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>




                        <div className='card home_all_courses_cards'>
                            <img src={cyberimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Security</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Cybersecurity & Ethical Hacking</h4>
                                <p className='text-justify'> Cybersecurity & Ethical Hacking protect systems, networks, and data from cyber threats. Ethical hackers identify vulnerabilities to strengthen security defenses. With rising cyberattacks, skilled professionals play a crucial role in safeguarding digital assets. Learning ethical hacking empowers individuals to combat cybercrime and secure the digital world.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>


                        <div className='card home_all_courses_cards'>
                            <img src={blockchainimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Technology</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Blockchain & Web3 Development</h4>
                                <p className='text-justify'> Blockchain & Web3 development revolutionizes digital interactions by enabling decentralized, transparent, and secure applications. It eliminates intermediaries, empowering users with true ownership of data and assets. Smart contracts automate trustless transactions, ensuring efficiency and security. This technology is shaping the future of finance, gaming, and the internet itself.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>


                        <div className='card home_all_courses_cards'>
                            <img src={IOTimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Technology</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Internet of Things (IoT) & Embedded Systems</h4>
                                <p className='text-justify'> The Internet of Things (IoT) & Embedded Systems revolutionize connectivity by enabling smart devices to communicate and automate tasks efficiently. IoT integrates sensors, software, and networks to collect and exchange data in real time. Embedded systems, being the backbone of IoT, are dedicated computing units optimized for specific functions. </p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={androidimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Mobile App Development (Android & iOS)</h4>
                                <p className='text-justify'> Mobile App Development for Android and iOS empowers businesses with seamless, user-friendly applications tailored for diverse audiences. It combines intuitive UI/UX design with robust backend integration to deliver high-performance apps. Leveraging modern frameworks like React Native, Flutter, and Swift, developers create scalable and feature-rich solutions. </p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={sqlimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>SQL & Database Management</h4>
                                <p className='text-justify'> SQL (Structured Query Language) is used to manage and manipulate relational databases efficiently. It enables users to create, read, update, and delete data using queries. Database management ensures data integrity, security, and performance optimization. Proper database design and indexing improve scalability and retrieval speed.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={testimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Testing</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Software Testing & Automation</h4>
                                <p className='text-justify'> Software Testing & Automation ensures the reliability, performance, and security of applications by identifying defects before deployment. Manual testing validates user experience, while automation accelerates repetitive tasks using frameworks like Selenium and Cypress. It improves efficiency, reduces human errors, and enhances test coverage. </p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={bigdataimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Technology</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Big Data & Apache Spark</h4>
                                <p className='text-justify'> Big Data refers to massive volumes of structured and unstructured data that require advanced processing techniques. Apache Spark is a powerful open-source framework designed for fast, distributed data processing. It supports real-time analytics, machine learning, and batch processing, making it ideal for handling big data workloads.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={promptimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Technology</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>Prompt Engineering & AI-Powered Automation</h4>
                                <p className='text-justify'> Prompt Engineering & AI-Powered Automation revolutionize how we interact with AI, optimizing responses for accuracy and efficiency. It enhances AI models by crafting precise prompts to generate meaningful outputs. Automation powered by AI streamlines workflows, reducing manual effort and boosting productivity. Together, they drive innovation, transforming industries with intelligent solutions.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                        <div className='card home_all_courses_cards'>
                            <img src={uiimg} />
                            <div className='home_all_courses_cards_content'>
                                <div className='home_all_courses_cards_fpcontent'>
                                    <p >Programming</p>
                                    <h6 className='cs2'><Link to='/contact-us'>For more details</Link></h6>
                                </div>
                                <h4>UI/UX Design & Web Development</h4>
                                <p className='text-justify'> UI/UX Design focuses on creating visually appealing and user-friendly experiences that enhance usability and engagement. Web Development brings these designs to life with clean, efficient, and responsive code. Together, they ensure seamless interaction, functionality, and performance across all devices.</p>
                                <Link to='/contact-us'> <button>
                                    Enroll Now <span><i class="ri-arrow-right-line"></i></span>
                                </button></Link>
                            </div>
                        </div>

                    </OwlCarousel>
                </div>
            </div>
        </div>
    );
};

export default HomeAllCourses;